// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__10uy5","filesListContainer":"PosDisputesFiles_filesListContainer__2ldS_","filesButton":"PosDisputesFiles_filesButton__2p1wV"};